import { getFormattedDate } from '../../utils/utilities';
import { DateRange } from 'rsuite/DateRangePicker';
import * as Yup from 'yup';
import { Shape } from '../yup_types';
import { TFunction } from 'react-i18next';
import { checkIfValidUUID } from '../../layout/core';
import { ISelectorData } from '../../components/application/NewApplication';
import { IOrderFilters } from '../../store/order/actions/order';

export enum ORDERS_FILTERS_FORM_FIELDS {
	STATUS = 'status',
	PLACED_DATE = 'placedDate',
	DEFAULT_PLACED_DATE = 'defaultPlacedDate',
	CREATED_DATE = 'createdDate',
	DEFAULT_CREATED_DATE = 'defaultCreatedDate',
	TIMEZONE = 'timezone',
	TYPE = 'isMIT',
	SITE_ID = 'sid',
	PARTNER_ID = 'pid',
	ORDER_ID = 'orderId',
	EXTERNAL_ORDER_ID = 'externalOrderId',
	EMAIL = 'email',
	FIRST_NAME = 'firstName',
	LAST_NAME = 'lastName',
	QUERY = 'query',
	FAVORITE_FILTERS = 'favoriteFilters',
	BIN = 'bin',
	LAST_4 = 'last4',
}

export enum ORDERS_FILTERS_FORM_FIELDS_NAMES {
	STATUS = 'ORDERS.FILTERS.STATUSES',
	PLACED_DATE = 'ORDERS.FILTERS.PLACED_DATE',
	CREATED_DATE = 'ORDERS.FILTERS.CREATED_DATE',
	TIMEZONE = 'ORDERS.FILTERS.TIMEZONE',
	TYPE = 'ORDERS.FILTERS.TYPE',
	SITE_ID = 'ORDERS.FILTERS.SITE_ID',
	PARTNER_ID = 'ORDERS.FILTERS.PARTNER_ID',
	ORDER_ID = 'ORDERS.FILTERS.ORDER_ID',
	EXTERNAL_ORDER_ID = 'ORDERS.FILTERS.EXTERNAL_ORDER_ID',
	EMAIL = 'ORDERS.FILTERS.EMAIL',
	FIRST_NAME = 'ORDERS.FILTERS.FIRST_NAME',
	LAST_NAME = 'ORDERS.FILTERS.LAST_NAME',
	FAVORITE_FILTERS = 'ORDERS.FILTERS.FAVORITE_FILTERS',
	FAVORITE_FILTERS_TOOLTIP = 'ORDERS.FILTERS.FAVORITE_FILTERS_TOOLTIP',
	BIN = 'ORDERS.FILTERS.BIN',
	LAST_4 = 'ORDERS.FILTERS.LAST_4',
}

export interface IOrderFiltersTypes {
	[ORDERS_FILTERS_FORM_FIELDS.STATUS]: string[],
	[ORDERS_FILTERS_FORM_FIELDS.PLACED_DATE]: Date[] | string[],
	[ORDERS_FILTERS_FORM_FIELDS.DEFAULT_PLACED_DATE]: DateRange,
	[ORDERS_FILTERS_FORM_FIELDS.CREATED_DATE]: Date[],
	[ORDERS_FILTERS_FORM_FIELDS.DEFAULT_CREATED_DATE]: DateRange,
	[ORDERS_FILTERS_FORM_FIELDS.TIMEZONE]: string,
	[ORDERS_FILTERS_FORM_FIELDS.TYPE]: string,
	[ORDERS_FILTERS_FORM_FIELDS.SITE_ID]: string,
	[ORDERS_FILTERS_FORM_FIELDS.ORDER_ID]: string,
	[ORDERS_FILTERS_FORM_FIELDS.PARTNER_ID]: string,
	[ORDERS_FILTERS_FORM_FIELDS.EXTERNAL_ORDER_ID]: string,
	[ORDERS_FILTERS_FORM_FIELDS.EMAIL]: string,
	[ORDERS_FILTERS_FORM_FIELDS.FIRST_NAME]: string,
	[ORDERS_FILTERS_FORM_FIELDS.LAST_NAME]: string,
	[ORDERS_FILTERS_FORM_FIELDS.QUERY]: string,
	[ORDERS_FILTERS_FORM_FIELDS.FAVORITE_FILTERS]: string[],
	[ORDERS_FILTERS_FORM_FIELDS.BIN]: number | string,
	[ORDERS_FILTERS_FORM_FIELDS.LAST_4]: number | string,
}

// @ts-ignore
export const getOrdersFiltersDetailsSchema = (t: TFunction): Yup.SchemaOf<IOrderFiltersTypes> => Yup.object<Shape<IOrderFiltersTypes>>().shape({
	[ORDERS_FILTERS_FORM_FIELDS.STATUS]: Yup.array().of(Yup.string()),
	[ORDERS_FILTERS_FORM_FIELDS.PLACED_DATE]: Yup.array().of(Yup.string()),
	[ORDERS_FILTERS_FORM_FIELDS.CREATED_DATE]: Yup.array().of(Yup.string()),
	[ORDERS_FILTERS_FORM_FIELDS.TIMEZONE]: Yup.string(),
	[ORDERS_FILTERS_FORM_FIELDS.TYPE]: Yup.string(),
	[ORDERS_FILTERS_FORM_FIELDS.SITE_ID]: Yup.string()
		.test('valid id', t('ORDERS.VALIDATION.ID_TEXT_ERROR'), (item) => {
			if (!item?.trim()) return true;
			return checkIfValidUUID(item);
		}),
	[ORDERS_FILTERS_FORM_FIELDS.EXTERNAL_ORDER_ID]: Yup.string(),
		// .test('valid id', t('ORDERS.VALIDATION.ID_TEXT_ERROR'), (item) => {
		// 	if (!item?.trim()) return true;
		// 	return checkIfValidUUID(item);
		// }),
	[ORDERS_FILTERS_FORM_FIELDS.ORDER_ID]: Yup.string()
		.test('valid id', t('ORDERS.VALIDATION.ID_TEXT_ERROR'), (item) => {
			if (!item?.trim()) return true;
			return checkIfValidUUID(item);
		}),
	[ORDERS_FILTERS_FORM_FIELDS.PARTNER_ID]: Yup.string()
		.test('valid id', t('ORDERS.VALIDATION.ID_TEXT_ERROR'), (item) => {
			if (!item?.trim()) return true;
			return checkIfValidUUID(item);
		}),
	[ORDERS_FILTERS_FORM_FIELDS.EMAIL]: Yup.string()
		.email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT')),
	[ORDERS_FILTERS_FORM_FIELDS.FIRST_NAME]: Yup.string(),
	[ORDERS_FILTERS_FORM_FIELDS.LAST_NAME]: Yup.string(),
	[ORDERS_FILTERS_FORM_FIELDS.QUERY]: Yup.string(),
	[ORDERS_FILTERS_FORM_FIELDS.FAVORITE_FILTERS]: Yup.array().of(Yup.string()),
	[ORDERS_FILTERS_FORM_FIELDS.BIN]: Yup.number()
		.test('valid bin', t('ORDERS.VALIDATION.BIN_ERROR'), (item) => {
			if (!item) return true;
			if (item?.toString()?.length === 6 || item?.toString()?.length === 8) return true;
		}),
	[ORDERS_FILTERS_FORM_FIELDS.LAST_4]: Yup.number()
		.test('valid last 4', t('ORDERS.VALIDATION.LAST_4_ERROR'), (item) => {
			if (!item) return true;
			return item?.toString()?.length === 4;
		})
});

// export interface IOrderFiltersReturnTypes {
// 	status?: string[],
// 	placedDate?: string[] | Date[],
// 	createdDate?: string[] | Date[],
// 	timezone?: string,
// 	isMIT?: string,
// 	sid?: string,
// 	pid?: string,
// 	orderId?: string,
// 	externalOrderId?: string,
// 	email?: string,
// 	firstName?: string,
// 	lastName?: string,
// 	query?: string,
// 	favoriteFilters?: string[],
// 	bin?: number | string,
// 	last4?: number | string,
// }

export const getInitialOrderFiltersValues = (orderStatuses: ISelectorData[], isSuperAdmin: boolean): IOrderFiltersTypes => {
	const todayStart = new Date();
	const todayEnd = new Date();
	todayStart.setHours(0, 0, 0);
	todayEnd.setHours(23, 59, 59);
	const showStartDate = getFormattedDate(todayStart, 'yyyy-MM-dd HH:mm:ss');
	const showEndDate = getFormattedDate(todayEnd, 'yyyy-MM-dd HH:mm:ss');
	const statuses = [];
	orderStatuses?.forEach(el => {
		// if (!isSuperAdmin) {
		// 	return statuses.push(el.value);
		// } else if (el.label.toLowerCase() === 'completed') {
		// 	return statuses.push(el.value);
		// }

		if (!isSuperAdmin && el.label.toLowerCase() === 'completed') {
			return statuses.push(el.value);
		}
	});
	return ({
		[ORDERS_FILTERS_FORM_FIELDS.STATUS]: statuses,
		[ORDERS_FILTERS_FORM_FIELDS.PLACED_DATE]: [],
		[ORDERS_FILTERS_FORM_FIELDS.DEFAULT_PLACED_DATE]: [new Date(showStartDate), new Date(showEndDate)],
		[ORDERS_FILTERS_FORM_FIELDS.CREATED_DATE]: [],
		[ORDERS_FILTERS_FORM_FIELDS.DEFAULT_CREATED_DATE]: [new Date(showStartDate), new Date(showEndDate)],
		[ORDERS_FILTERS_FORM_FIELDS.TIMEZONE]: 'UTC',
		[ORDERS_FILTERS_FORM_FIELDS.TYPE]: '',
		[ORDERS_FILTERS_FORM_FIELDS.SITE_ID]: '',
		[ORDERS_FILTERS_FORM_FIELDS.PARTNER_ID]: '',
		[ORDERS_FILTERS_FORM_FIELDS.ORDER_ID]: '',
		[ORDERS_FILTERS_FORM_FIELDS.EXTERNAL_ORDER_ID]: '',
		[ORDERS_FILTERS_FORM_FIELDS.EMAIL]: '',
		[ORDERS_FILTERS_FORM_FIELDS.FIRST_NAME]: '',
		[ORDERS_FILTERS_FORM_FIELDS.LAST_NAME]: '',
		[ORDERS_FILTERS_FORM_FIELDS.QUERY]: '',
		[ORDERS_FILTERS_FORM_FIELDS.FAVORITE_FILTERS]: [],
		[ORDERS_FILTERS_FORM_FIELDS.BIN]: '',
		[ORDERS_FILTERS_FORM_FIELDS.LAST_4]: '',
	});
};

export const getFormattedOrderFiltersFormFields = (formikValues): IOrderFilters => ({
	status: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.STATUS],
	placedFrom: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.PLACED_DATE]?.[0],
	placedTo: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.PLACED_DATE]?.[1],
	from: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.CREATED_DATE]?.[0],
	to: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.CREATED_DATE]?.[1],
	timezone: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.TIMEZONE],
	isMIT: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.TYPE],
	sid: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.SITE_ID],
	pid: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.PARTNER_ID],
	orderId: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.ORDER_ID],
	externalOrderId: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.EXTERNAL_ORDER_ID],
	email: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.EMAIL],
	firstName: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.FIRST_NAME],
	lastName: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.LAST_NAME],
	query: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.QUERY],
	bin: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.BIN],
	last4: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.LAST_4],
	// favoriteFilters: formikValues?.[ORDERS_FILTERS_FORM_FIELDS.FAVORITE_FILTERS],
});

export const getFormattedFavoriteOrderFilters = (formikValues): string[] => (formikValues?.[ORDERS_FILTERS_FORM_FIELDS.FAVORITE_FILTERS]);

export const convertToOrdersFiltersInitial = (data, orderStatuses: ISelectorData[]):IOrderFiltersTypes => {
	const todayStart = new Date();
	const todayEnd = new Date();
	todayStart.setHours(0, 0, 0);
	todayEnd.setHours(23, 59, 59);
	const showStartDate = getFormattedDate(todayStart, 'yyyy-MM-dd HH:mm:ss');
	const showEndDate = getFormattedDate(todayEnd, 'yyyy-MM-dd HH:mm:ss');

	const getType = (): string => {
		if (data?.isMIT?.toLowerCase() === 'true') {
			return 'MIT';
		}
		if (data?.isMIT?.toLowerCase() === 'false') {
			return 'CIT';
		}
		return '';
	};
	console.log('data', data);
	const getStatus = (): string[] => {
		const formattedStatusArr = [];
		if (Array.isArray(data?.status)) {
			formattedStatusArr.push(...(data?.status || []));
		} else if (data?.status) {
			formattedStatusArr.push(data?.status);
		}
		if (data?.types) {
			const chargebackStatus = orderStatuses?.find(el => el.label.toLowerCase() === 'chargeback')?.value;
			formattedStatusArr.push(chargebackStatus);
		}
		return formattedStatusArr || [];
	};

	return ({
		[ORDERS_FILTERS_FORM_FIELDS.STATUS]: getStatus(),
		[ORDERS_FILTERS_FORM_FIELDS.PLACED_DATE]: data?.placedFrom && data?.placedTo
			? [new Date(data?.placedFrom), new Date(data?.placedTo)]
			: [],
		[ORDERS_FILTERS_FORM_FIELDS.DEFAULT_PLACED_DATE]: [new Date(showStartDate), new Date(showEndDate)],
		[ORDERS_FILTERS_FORM_FIELDS.CREATED_DATE]: data?.from && data?.to
			? [new Date(data?.from), new Date(data?.to)]
			: [],
		[ORDERS_FILTERS_FORM_FIELDS.DEFAULT_CREATED_DATE]: [new Date(showStartDate), new Date(showEndDate)],
		[ORDERS_FILTERS_FORM_FIELDS.TIMEZONE]: data?.timezone ? data?.timezone : 'UTC',
		[ORDERS_FILTERS_FORM_FIELDS.TYPE]: getType(),
		[ORDERS_FILTERS_FORM_FIELDS.SITE_ID]: data?.sid ? data?.sid : '',
		[ORDERS_FILTERS_FORM_FIELDS.PARTNER_ID]: data?.pid ? data?.pid : '',
		[ORDERS_FILTERS_FORM_FIELDS.ORDER_ID]: data?.orderId ? data?.orderId : '',
		[ORDERS_FILTERS_FORM_FIELDS.EXTERNAL_ORDER_ID]: data?.externalOrderId ? data?.externalOrderId : '',
		[ORDERS_FILTERS_FORM_FIELDS.EMAIL]: data?.email ? data?.email : '',
		[ORDERS_FILTERS_FORM_FIELDS.FIRST_NAME]: data?.firstName ? data?.firstName : '',
		[ORDERS_FILTERS_FORM_FIELDS.LAST_NAME]: data?.lastName ? data?.lastName : '',
		[ORDERS_FILTERS_FORM_FIELDS.QUERY]: data?.query ? data?.query : '',
		[ORDERS_FILTERS_FORM_FIELDS.FAVORITE_FILTERS]: data?.favoriteFilters ? data?.favoriteFilters : [],
		[ORDERS_FILTERS_FORM_FIELDS.BIN]: data?.bin ? data?.bin : '',
		[ORDERS_FILTERS_FORM_FIELDS.LAST_4]: data?.last4 ? data?.last4 : '',
	});
};

export const getOrderFiltersList = (t: TFunction): ISelectorData[] => [
	// {
	// 	value: ORDERS_FILTERS_FORM_FIELDS.STATUS,
	// 	label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.STATUS),
	// },
	{
		value: ORDERS_FILTERS_FORM_FIELDS.PARTNER_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.PARTNER_ID),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.SITE_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.SITE_ID),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.ORDER_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.ORDER_ID),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.EXTERNAL_ORDER_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.EXTERNAL_ORDER_ID),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.PLACED_DATE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.PLACED_DATE),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.CREATED_DATE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.CREATED_DATE),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.FIRST_NAME,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.FIRST_NAME),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.LAST_NAME,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.LAST_NAME),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.EMAIL,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.EMAIL),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.TYPE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.TYPE),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.TIMEZONE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.TIMEZONE),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.BIN,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.BIN),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.LAST_4,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.LAST_4),
	},
];

export const getIntegrationPartnerOrderFiltersList = (t: TFunction): ISelectorData[] => [
	// {
	// 	value: ORDERS_FILTERS_FORM_FIELDS.STATUS,
	// 	label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.STATUS),
	// },
	{
		value: ORDERS_FILTERS_FORM_FIELDS.SITE_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.SITE_ID),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.ORDER_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.ORDER_ID),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.EXTERNAL_ORDER_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.EXTERNAL_ORDER_ID),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.PLACED_DATE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.PLACED_DATE),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.CREATED_DATE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.CREATED_DATE),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.FIRST_NAME,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.FIRST_NAME),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.LAST_NAME,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.LAST_NAME),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.EMAIL,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.EMAIL),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.TYPE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.TYPE),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.BIN,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.BIN),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.LAST_4,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.LAST_4),
	},
	{
		value: ORDERS_FILTERS_FORM_FIELDS.TIMEZONE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.TIMEZONE),
	},
];
